import { createSelector } from "reselect";
import get from "lodash/get";
import { userSINSelector } from "../authInfo";
import { REPORT_LOST_SIM_REASON, forms } from "utils/constants";
import {
  selectAppSettings,
  orderRefSelector,
  sessionTokenSelector,
  orderDetailsSelector,
  genericSelector,
  userOrdersDetailsSelector,
  formValuesSelector
} from "ducks/selectors";

// ***************************************************************
// ************** reportLostSimForm selectors ******************
// ***************************************************************

export const reportLostSimSelector = formValuesSelector(
  forms.REPORT_LOST_SIM_FORM
);

// ***************************************************************
// *************** reportLostSimForm makeSelect *******************
// ***************************************************************

export const makeSelectReportLostSimForm = () => reportLostSimSelector;

export const makeSelectReportLostSimPayload = () =>
  createSelector(
    reportLostSimSelector,
    orderRefSelector,
    sessionTokenSelector,
    orderDetailsSelector,
    userSINSelector,
    (reportLostSim, order_ref, session_token, orderDetails, accountNumber) => {
      const isESIM = ["ESIM", "ESIM_5G"].includes(
        get(reportLostSim, "replacement_sim_type.value")
      );
      return {
        accountNumber,
        order_ref,
        session_token,
        sim_type: isESIM ? "ESIM" : "PHYSICAL_SIM",
        primary_id: get(reportLostSim, "primary_id"),
        switch_to_esim: false,
        skip_form_submission:
          get(orderDetails, "state") === "DELIVERY_FAILED" ||
          get(orderDetails, "in_progress"),
        inventoryType: get(reportLostSim, "sim_replacement_type"),
        reason:
          get(reportLostSim, "sim_replacement_reason.value") ||
          REPORT_LOST_SIM_REASON,
        nric: get(reportLostSim, "primary_id") || get(reportLostSim, "nric")
      };
    }
  );

export const makeSelectReportLostFormInitialValues = () =>
  createSelector(
    genericSelector,
    orderDetailsSelector,
    userOrdersDetailsSelector,
    (generic, orderDetails, userOrdersDetails) => {
      return {
        country_code: get(generic, "contact_number.prefix"),
        ...userOrdersDetails,
        contact_number: get(
          userOrdersDetails,
          "contact_number",
          get(orderDetails, "phone_number")
        )
      };
    }
  );

export const makeSelectSimReplacementReasons = () =>
  createSelector(
    selectAppSettings,
    reportLostSimSelector,
    (appSettings, reportLostSimForm) => {
      const replacement_sim_type =
        reportLostSimForm?.replacement_sim_type?.value;
      return (
        get(
          appSettings,
          `sim_replacement_reasons_for_sim_type.${replacement_sim_type}`
        ) || []
      );
    }
  );
